module.exports = __webpack_public_path__ + "static/media/3-IMG_6687.4b476373.JPG";